import UObject from "@repo/utils/UObject";

declare namespace ExpressiveIcon {
  type Props = {
    class?: string;
    name: keyof typeof svgByName | keyof typeof webpByName;
    size: "small" | "medium" | "large" | "x-large";
  };
}

function ExpressiveIcon({
  class: className,
  name,
  size,
}: D<ExpressiveIcon.Props>) {
  return (
    <img
      src={
        name in svgByName
          ? svgByName[name as keyof typeof svgByName]
          : webpByName[name as keyof typeof webpByName]
      }
      style={{
        width: `var(--icon-${size})`,
        // height: `var(--icon-${size})`,
      }}
      class={className}
    />
  );
}

export default ExpressiveIcon;

const svgByName = UObject.trimKeys(
  // prettier-ignore
  import.meta.glob("./assets/expressiveIcons/*.svg", {
    eager: true,
    import: "default",
  }) as {
/* GENERATED */ "./assets/expressiveIcons/calendar.svg": typeof import("./assets/expressiveIcons/calendar.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/celebrate.svg": typeof import("./assets/expressiveIcons/celebrate.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/closeMyAccount.svg": typeof import("./assets/expressiveIcons/closeMyAccount.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/creditCashback.svg": typeof import("./assets/expressiveIcons/creditCashback.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/creditReport.svg": typeof import("./assets/expressiveIcons/creditReport.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/depositACheck.svg": typeof import("./assets/expressiveIcons/depositACheck.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/fraudProtection.svg": typeof import("./assets/expressiveIcons/fraudProtection.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/kikoffCard.svg": typeof import("./assets/expressiveIcons/kikoffCard.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/kikoffCredit.svg": typeof import("./assets/expressiveIcons/kikoffCredit.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/locationPermission.svg": typeof import("./assets/expressiveIcons/locationPermission.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/mailbox.svg": typeof import("./assets/expressiveIcons/mailbox.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/moveDirectDeposit.svg": typeof import("./assets/expressiveIcons/moveDirectDeposit.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/myOrders.svg": typeof import("./assets/expressiveIcons/myOrders.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/privacy.svg": typeof import("./assets/expressiveIcons/privacy.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/rocket.svg": typeof import("./assets/expressiveIcons/rocket.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/safe.svg": typeof import("./assets/expressiveIcons/safe.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/savings.svg": typeof import("./assets/expressiveIcons/savings.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/security.svg": typeof import("./assets/expressiveIcons/security.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/setUpBillPay.svg": typeof import("./assets/expressiveIcons/setUpBillPay.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/settings.svg": typeof import("./assets/expressiveIcons/settings.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/shopAtKikoffStore.svg": typeof import("./assets/expressiveIcons/shopAtKikoffStore.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/starterLoan.svg": typeof import("./assets/expressiveIcons/starterLoan.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/statements.svg": typeof import("./assets/expressiveIcons/statements.svg")["default"],
/* GENERATED */ "./assets/expressiveIcons/withdraw.svg": typeof import("./assets/expressiveIcons/withdraw.svg")["default"]
},
  "./assets/expressiveIcons/",
  ".svg"
);

const webpByName = UObject.trimKeys(
  // prettier-ignore
  import.meta.glob("./assets/expressiveIcons/*.webp", {
    eager: true,
    import: "default",
  }) as {
/* GENERATED */ "./assets/expressiveIcons/rocket-detailed.webp": typeof import("./assets/expressiveIcons/rocket-detailed.webp")["default"]
},
  "./assets/expressiveIcons/",
  ".webp"
);
